// Track engagement signals that improve SEO rankings
(function () {
  const engagementData = {
    scrollDepth: 0,
    timeOnPage: 0,
    interactions: 0,
    maxScroll: 0,
  };

  const startTime = Date.now();

  // 1. Scroll Progress Bar (increases perceived speed & engagement)
  const scrollProgress = document.getElementById('scrollProgress');
  const readingProgress = document.getElementById('readingProgress');
  const readingPercent = document.getElementById('readingPercent');

  // Scroll work runs through the shared coordinator (assets/scroll-coordinator.js).
  // This handler already cached the scrollable height and batched its writes into
  // one animation frame, and it still measured 473-508ms of forced layout: it was
  // one of three independent frames landing in the same tick, so whichever ran
  // second read geometry that the first had just dirtied. Caching and batching cap
  // how often a forced layout happens; only a page-wide read phase removes it.
  let readingVisible = null;
  let lastPercentText = null;

  // Read phase. Every value comes from the coordinator's single measurement for
  // the frame, so nothing here touches the document.
  function readScrollProgress(metrics) {
    if (metrics.maxScroll <= 0) return null;
    const scrolled = (metrics.scrollY / metrics.maxScroll) * 100;
    return { scrolled: scrolled, rounded: Math.round(scrolled) };
  }

  // Write phase. Style only, and each write is skipped when the value has not
  // changed, so a scroll burst produces at most one mutation per element per frame.
  function writeScrollProgress(state) {
    if (!state) return;

    if (scrollProgress) {
      scrollProgress.style.width = state.scrolled + '%';
    }

    engagementData.maxScroll = Math.max(engagementData.maxScroll, state.rounded);

    if (readingProgress) {
      const shouldShow = state.scrolled > 10;
      if (shouldShow !== readingVisible) {
        readingVisible = shouldShow;
        readingProgress.classList.toggle('visible', shouldShow);
      }
      if (shouldShow && readingPercent) {
        const text = state.rounded + '%';
        if (text !== lastPercentText) {
          lastPercentText = text;
          readingPercent.textContent = text;
        }
      }
    }
  }

  window.CoraScroll.subscribe({
    name: 'scroll-progress',
    read: readScrollProgress,
    write: writeScrollProgress,
  });

  // 2. Track Time on Page (dwell time ranking signal)
  setInterval(function () {
    engagementData.timeOnPage = Math.round((Date.now() - startTime) / 1000);
  }, 1000);

  // 3. Track Interactions (engagement ranking signal)
  const interactionEvents = ['click', 'touchstart', 'keydown'];
  interactionEvents.forEach(function (event) {
    document.addEventListener(
      event,
      function () {
        engagementData.interactions++;
      },
      { passive: true, once: false }
    );
  });

  // 4. Smooth scroll to anchors (better UX = better engagement)
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link || !link.hash) return;

    const target = document.querySelector(link.hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Update URL without jumping
      if (history.pushState) {
        history.pushState(null, null, link.hash);
      }
    }
  });

  // 5. Send engagement signals on page exit (for analytics)
  window.addEventListener('beforeunload', function () {
    // Could send to analytics here:
    // navigator.sendBeacon('/analytics', JSON.stringify(engagementData));
  });

  // 6. Reduce bounce rate with "read more" encouragement
  const scrollDepthMilestones = [25, 50, 75, 100];
  const achievedMilestones = [];

  // Milestone checks ride the coordinator's write phase rather than their own
  // scroll listener: they read no geometry, but a listener still woke on every
  // scroll event to redo the same array scan. Once per frame is enough, and it
  // runs after writeScrollProgress has updated maxScroll for this frame.
  window.CoraScroll.subscribe({
    name: 'scroll-depth-milestones',
    write: function () {
      const scrollPercent = engagementData.maxScroll;

      scrollDepthMilestones.forEach(function (milestone) {
        if (scrollPercent >= milestone && !achievedMilestones.includes(milestone)) {
          achievedMilestones.push(milestone);

          // Fire custom event for analytics
          document.dispatchEvent(
            new CustomEvent('scrollDepth', {
              detail: { depth: milestone },
            })
          );
        }
      });
    },
  });

  // 7. Auto-scroll hint: never built. Both branches of the "does the page even
  // scroll" test were empty, so the only thing this block ever did was read
  // document.documentElement.scrollHeight at module-execution time, forcing a
  // full synchronous layout of a 7,245-element DOM for a decision nothing acted
  // on. Measured at 267-285ms on a 6x-throttled 2GB Android profile, in every
  // probe run, and it survived the coordinator migration because the migration
  // only ever touched the scroll path. Deleting it removes no behavior: there
  // was none. If the hint is ever built, take the height from the coordinator's
  // shared metrics inside a subscriber rather than measuring here.
})();
